import axios from 'axios'

// baseURL: 'http://127.0.0.1:8000/api', // Replace with your URL
const api = axios.create({
  baseURL: 'https://duesgenerator.juanalexisaldana.a2hosted.com/api', // Replace with your URL
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
})

// ✅ This Interceptor ensures the token is sent with every request
api.interceptors.request.use(config => {
  const token = localStorage.getItem('user-token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
}, error => {
  return Promise.reject(error)
})

export default api